'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _icon_check2x = require('images/home/icon_check@2x.png');

var _icon_check2x2 = _interopRequireDefault(_icon_check2x);

var _HS_logo_white = require('landing-pages/assets/HS_logo_white.svg');

var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);

var _gmail_logo = require('landing-pages/assets/gmail_logo.svg');

var _gmail_logo2 = _interopRequireDefault(_gmail_logo);

var _clouds_gmail = require('landing-pages/assets/clouds_gmail.svg');

var _clouds_gmail2 = _interopRequireDefault(_clouds_gmail);

var _overlay_left = require('landing-pages/assets/overlay_left.svg');

var _overlay_left2 = _interopRequireDefault(_overlay_left);

var _overlay_right = require('landing-pages/assets/overlay_right.svg');

var _overlay_right2 = _interopRequireDefault(_overlay_right);

var _signature_icon = require('landing-pages/assets/signature_icon.svg');

var _signature_icon2 = _interopRequireDefault(_signature_icon);

var _clock_icon = require('landing-pages/assets/clock_icon.svg');

var _clock_icon2 = _interopRequireDefault(_clock_icon);

var _security_icon = require('landing-pages/assets/security_icon.svg');

var _security_icon2 = _interopRequireDefault(_security_icon);

var _screenshot_gmail = require('landing-pages/assets/screenshot_gmail.png');

var _screenshot_gmail2 = _interopRequireDefault(_screenshot_gmail);

var _socialSection = require('landing-pages/components/common/social-section');

var _socialSection2 = _interopRequireDefault(_socialSection);

var _faqSection = require('landing-pages/components/common/faq-section');

var _faqSection2 = _interopRequireDefault(_faqSection);

var _howItWorksSection = require('landing-pages/components/common/how-it-works-section');

var _howItWorksSection2 = _interopRequireDefault(_howItWorksSection);

var _benefitsSection = require('landing-pages/components/common/benefits-section');

var _benefitsSection2 = _interopRequireDefault(_benefitsSection);

var _pricingCtaSection = require('landing-pages/components/common/pricing-cta-section');

var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function Gmail(p) {
    // Gmail constants
    var benefits = [{
        icon: _signature_icon2['default'],
        title: 'Stay focused on tasks',
        text: 'Forget downloading and then uploading to another site—now you never need to even leave Gmail to sign a document.'
    }, {
        icon: _clock_icon2['default'],
        title: 'Sign documents faster',
        text: 'It takes less than 30 seconds to sign a contract, so you\'ll be able to get through your inbox faster.'
    }, {
        icon: _security_icon2['default'],
        title: 'Secure your legal documents',
        text: 'All signed documents are legally binding and automatically backed up in your HelloSign account.'
    }];
    var howItWorks = ['Once you install the HelloSign for Gmail chrome browser extension, documents you receive as attachments in Gmail will have a “Sign” button.', 'Click the “Sign” button to load the HelloSign signature window, sign, and send. You can also choose to download the signed document.', 'All of the documents you send through the extension will show up in the documents view on HelloSign.com.'];
    var twitterLink = 'https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fwww.hellosign.com%2Fgmail&ref_src=twsrc%5Etfw&text=Did%20you%20know%20%40HelloSign%20integrates%20with%20%40Gmail%3F%20Sign%20documents%20directly%20in%20your%20Gmail%20inbox.&tw_p=tweetbutton&url=http%3A%2F%2Fwww.hellosign.com%2Fgmail%26utm_medium%3Ds2s%26utm_source%3Dtwitter';
    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/gmail?utm_source=facebook%26utm_medium=s2s';
    var linkedInLink = 'https://www.linkedin.com/cws/share?url=https%3A%2F%2Fwww.hellosign.com%2Fgmail%3Futm_medium%3Ds2s%26utm_source%3Dlinkedin&original_referer=https%3A%2F%2Fwww.hellosign.com%2Fgmail&token=&isFramed=false&lang=en_US&_ts=1462214138386.6147&xd_origin_host=https%3A%2F%2Fwww.hellosign.com';
    var border = '2px solid #D7D7D7';

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations' },
        _react2['default'].createElement(GmailInstalledArea, null),
        _react2['default'].createElement(IllustrationArea, p),
        _react2['default'].createElement(
            'div',
            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top', style: { borderBottom: border, backgroundColor: '#F7F8F9', fontWeight: 600 } }),
            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
            _react2['default'].createElement(_howItWorksSection2['default'], {
                image: _screenshot_gmail2['default'],
                explanation: howItWorks }),
            _react2['default'].createElement(Quote, null),
            _react2['default'].createElement(_socialSection2['default'], {
                title: 'Share with your networks!',
                twitterLink: twitterLink,
                facebookLink: facebookLink,
                linkedInLink: linkedInLink }),
            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/200977977' }),
            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom', style: { borderTop: border, fontWeight: 600 } })
        )
    );
}

function GmailInstalledArea(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'l-padding-t-80 l-padding-b-80 gmail-not-installed bg-deep-blue text-center' },
        _react2['default'].createElement('img', { src: _icon_check2x2['default'], width: '51', className: 'l-padding-b-20' }),
        _react2['default'].createElement(
            'h3',
            { style: { color: 'white' } },
            'Installed! Log in to Gmail to start signing documents.'
        ),
        _react2['default'].createElement(_button2['default'], {
            buttonTextColor: 'cerulean',
            buttonLink: 'https://www.gmail.com',
            buttonText: 'Go to Gmail now',
            buttonHoverTextColor: 'white',
            buttonColor: 'white' })
    );
}

function handleClick(e) {
    e.preventDefault();
    var config = window.config;
    var ua = navigator.userAgent.toLowerCase();
    if (/safari/.test(ua) && !/chrome/.test(ua)) {
        window.open(config.open_id_safari, '_blank', 'width=640, height=480');
    } else if (/firefox/.test(ua)) {
        window.open(config.open_id_firefox, '_blank', 'width=640, height=480');
    } else {
        chrome.webstore.install(config.chrome_store, function (e) {
            location.reload();
        }, function (e) {
            console.log(e);
        });
    }
}

function IllustrationArea(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'top row', style: { backgroundColor: '#FAB697' } },
        _react2['default'].createElement(
            'div',
            { className: 'top-content-container large-5 large-push-6 columns' },
            _react2['default'].createElement(
                'div',
                { className: 'hellosign-dropbox' },
                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
                _react2['default'].createElement(
                    'span',
                    { className: 'plus' },
                    '+'
                ),
                _react2['default'].createElement('img', { src: _gmail_logo2['default'], alt: 'Dropbox Logo', className: 'dropbox-logo', style: { width: 120, marginLeft: 28 } })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'title' },
                _react2['default'].createElement(
                    'h1',
                    null,
                    'Sign documents in Gmail'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'subtitle' },
                _react2['default'].createElement(
                    'h2',
                    null,
                    'Fill out and sign documents in less than 30 seconds without ever leaving Gmail. Our easy-to-use Chrome browser extension lets you sign attachments right from your inbox. Never print, sign, and scan again!'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'signup-button' },
                _react2['default'].createElement(_button2['default'], {
                    buttonText: 'Try it free',
                    onClick: handleClick,
                    buttonColor: 'cerulean',
                    buttonTextColor: 'white',
                    buttonClass: 'gmail-not-installed',
                    buttonId: 'try-it-free-link' })
            )
        ),
        _react2['default'].createElement(
            'div',
            { className: 'clouds-container large-5 large-pull-4 columns' },
            _react2['default'].createElement('img', { src: _clouds_gmail2['default'], alt: 'cloud left' })
        ),
        _react2['default'].createElement('img', { src: _overlay_left2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud left', className: 'cloud-left' }),
        _react2['default'].createElement('img', { src: _overlay_right2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud right', className: 'cloud-right' })
    );
}

function Quote(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__quote-container' },
        _react2['default'].createElement(
            'p',
            { className: 'quote', style: { textAlign: 'center' } },
            '\'HelloSign for Gmail is awesome!\''
        ),
        _react2['default'].createElement(
            'p',
            { className: 'quote-name' },
            'PAUL BUCHHEIT'
        ),
        _react2['default'].createElement(
            'p',
            { className: 'quote-title' },
            'Creator of Gmail and investor in HelloSign'
        )
    );
}

module.exports = Gmail;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/gmail.jsx
 ** module id = 1641
 ** module chunks = 0
 **/